import React from 'react';
import Header from '../components/Header';

const Support = () => {
  return (
    <div>
        <Header />

        <section className="relative flex items-center justify-center bg-gradient-to-t to-[#f6fcff] from-[#cef0ff] h-screen">
            <div className="max-w-[1500px] mx-auto px-5 xl:px-16 flex flex-col lg:flex-row justify-between center">
                <div className="w-full">
                    <p className="text-4xl capitalize leading-tight text-[#05364D] mb-10 text-center">Stuck? Don’t Worry, We’re Here to Help.</p>
                    <p className='tracking-[.2rem] text-xl font-light text-[#05364D] mb-4 text-center'>Click the chat icon below.</p>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Support;